"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentStructure = exports.getBuildingName = exports.getBuildingIdList = exports.diff = exports.checkWebPSupport = exports.areEqual = exports.SomeValue = void 0;
Object.defineProperty(exports, "getCurrentStructureWithHtgHx", {
  enumerable: true,
  get: function get() {
    return _helpers.getCurrentStructureWithHtgHx;
  }
});
exports.wrongData = exports.wrapInArray = exports.valueExist = exports.ucFirst = exports.toastMessageCreator = exports.throwErrorIfIsNotCondition = exports.textIsPlacedInBlock = exports.stringToColor = exports.stringAvatar = exports.setToSessionStorage = exports.setToLocalStorage = exports.removeFromSessionStorage = exports.removeFromLocalStorage = exports.percentageToHsl = exports.parseByValueType = exports.oldData = exports.mobileSize = exports.isSameCurrentDateByDay = exports.isMobile = exports.isEmpty = exports.isArray = exports.getToYear = exports.getToMonth = exports.getToDay = exports.getTo7Day = exports.getTo14Day = exports.getTimeDifference = exports.getTextByLanguage = exports.getSupportedImg = exports.getStringId = exports.getStatusDevice = exports.getStartMonth = exports.getStartDay = exports.getSignalStatusColorGradient = exports.getSignalStatusColor = exports.getSignalRangeKey = exports.getSignalColorSettings = exports.getRandomID = exports.getKeys = exports.getKeyByValue = exports.getIsCorrectTemperature = exports.getFromYear = exports.getFromStartYear = exports.getFromStartMonth = exports.getFromSessionStorage = exports.getFromMonth = exports.getFromMax = exports.getFromLocalStorage = exports.getFromDay = exports.getFrom7Day = exports.getFrom16Day = exports.getEndMonth = exports.getEndDay = exports.getDisplayClassificationVersion = exports.getDisplayClassification = exports.getDeviceModelType = exports.getDateFormat = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactToastify = require("react-toastify");
var _constants = require("./constants");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Types = require("../Types");
var _ToastContent = require("../components/ToastContent");
var _helpers = require("../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import of react is used for toastMessageCreator func, because of the issue: React is undefined when importing and using a func in other packages. TODO: take a look after the issue resolved https://github.com/fkhadra/react-toastify/issues/797.
const SomeValue = (obj, sFunc) => Object.keys(obj).some(sFunc);
exports.SomeValue = SomeValue;
const setToLocalStorage = (name, value) => localStorage.setItem(name, JSON.stringify(value));
exports.setToLocalStorage = setToLocalStorage;
const removeFromLocalStorage = name => localStorage.removeItem(name);
exports.removeFromLocalStorage = removeFromLocalStorage;
const getFromLocalStorage = name => JSON.parse(localStorage.getItem(name) !== 'undefined' ? localStorage.getItem(name) : 'null');
exports.getFromLocalStorage = getFromLocalStorage;
const setToSessionStorage = (name, data) => sessionStorage.setItem(name, data);
exports.setToSessionStorage = setToSessionStorage;
const getFromSessionStorage = name => sessionStorage.getItem(name) !== 'undefined' ? sessionStorage.getItem(name) : 'null';
exports.getFromSessionStorage = getFromSessionStorage;
const removeFromSessionStorage = name => sessionStorage.removeItem(name);
exports.removeFromSessionStorage = removeFromSessionStorage;
const isMobile = exports.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const mobileSize = exports.mobileSize = window.innerWidth < 992;
const isArray = v => Array.isArray(v);
exports.isArray = isArray;
const isEmpty = obj => obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
exports.isEmpty = isEmpty;
const getBuildingIdList = _ref => {
  let {
    structure = {}
  } = _ref;
  const {
    HtgSys,
    HtgSub
  } = structure;
  let uniqueBuildings = [];
  const addToList = function addToList() {
    var _Object$values;
    let equipmentsByType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (_Object$values = Object.values(equipmentsByType)) === null || _Object$values === void 0 ? void 0 : _Object$values.reduce((acc, equipment) => {
      if (!equipment.building.length || equipment.building.find(building => uniqueBuildings.includes(building)) || acc.find(building => areEqual(building, equipment.building))) {
        return acc;
      }
      uniqueBuildings = uniqueBuildings.concat(equipment.building);
      return [...acc, equipment.building];
    }, []);
  };
  return [...addToList(HtgSys), ...addToList(HtgSub)];
};
exports.getBuildingIdList = getBuildingIdList;
getBuildingIdList.propTypes = {
  structure: _Types.structureType
};
const checkWebPSupport = async () => {
  return new Promise(res => {
    const webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    webP.onload = webP.onerror = () => {
      res(webP.height === 2);
    };
  });
};
exports.checkWebPSupport = checkWebPSupport;
const diff = exports.diff = function diff() {
  let a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a1.filter(i => !a2.includes(i)).concat(a2.filter(i => !a1.includes(i)));
};
const getKeys = obj => Object.keys(obj);
exports.getKeys = getKeys;
const getKeyByValue = (object, value) => getKeys(object).find(key => object[key] === value);
exports.getKeyByValue = getKeyByValue;
const getDateFormat = (date, format) => (0, _moment.default)((0, _moment.default)(date).format()).format(format || 'DD.MM.YYYY');
exports.getDateFormat = getDateFormat;
const getStartDay = d => (0, _moment.default)(d).startOf('day');
exports.getStartDay = getStartDay;
const getStartMonth = d => (0, _moment.default)(d).startOf('month');
exports.getStartMonth = getStartMonth;
const getEndDay = d => (0, _moment.default)(d).endOf('day');
exports.getEndDay = getEndDay;
const getEndMonth = d => (0, _moment.default)(d).endOf('month');
exports.getEndMonth = getEndMonth;
const getFromDay = d => (0, _moment.default)(d).subtract(1, 'day');
exports.getFromDay = getFromDay;
const getFrom7Day = d => (0, _moment.default)(d).subtract(6, 'days');
exports.getFrom7Day = getFrom7Day;
const getFrom16Day = d => (0, _moment.default)(d).subtract(16, 'days');
exports.getFrom16Day = getFrom16Day;
const getFromMonth = d => (0, _moment.default)(d).subtract(1, 'month');
exports.getFromMonth = getFromMonth;
const getFromYear = d => (0, _moment.default)(d).subtract(365, 'days');
exports.getFromYear = getFromYear;
const getFromMax = () => (0, _moment.default)('01-01-2022');
exports.getFromMax = getFromMax;
const getFromStartMonth = d => (0, _moment.default)(d).startOf('month');
exports.getFromStartMonth = getFromStartMonth;
const getFromStartYear = d => (0, _moment.default)(d).startOf('year');
exports.getFromStartYear = getFromStartYear;
const getToDay = d => (0, _moment.default)(d).add(1, 'day');
exports.getToDay = getToDay;
const getTo7Day = d => (0, _moment.default)(d).add(6, 'days');
exports.getTo7Day = getTo7Day;
const getTo14Day = d => (0, _moment.default)(d).add(13, 'days');
exports.getTo14Day = getTo14Day;
const getToMonth = d => (0, _moment.default)(d).add(1, 'month');
exports.getToMonth = getToMonth;
const getToYear = d => (0, _moment.default)(d).add(365, 'days');
exports.getToYear = getToYear;
const isSameCurrentDateByDay = d => (0, _moment.default)().isSame((0, _moment.default)(d), 'day');
exports.isSameCurrentDateByDay = isSameCurrentDateByDay;
const getTimeDifference = timestamp => (0, _moment.default)().diff((0, _moment.default)(timestamp), 'minute');
exports.getTimeDifference = getTimeDifference;
const wrapInArray = v => typeof v === 'number' ? [v] : typeof v === 'object' ? Object.values(v) : v;
exports.wrapInArray = wrapInArray;
const stringToColor = exports.stringToColor = function stringToColor() {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = hash >> i * 8 & 0xff;
    color += value ? "00".concat(value.toString(16)).slice(-2) : '#bdbdbd';
  }
  /* eslint-enable no-bitwise */
  return color;
};
const stringAvatar = exports.stringAvatar = function stringAvatar() {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    sx: {
      bgcolor: stringToColor(name)
    },
    children: "".concat(name.split(' ')[0][0] || 'A').concat(name.split(' ')[1] ? name.split(' ')[1][0] : '')
  };
};
const getRandomID = () => Math.random();
exports.getRandomID = getRandomID;
const getStringId = exports.getStringId = function getStringId() {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
/** @deprecated getTextByLanguage */
const getTextByLanguage = exports.getTextByLanguage = function getTextByLanguage(text) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    defaultText = ''
  } = params;
  const activeLanguage = 'en-US';
  const defaultLanguage = 'de-DE';
  switch (typeof text) {
    case 'object':
      return text ? text[activeLanguage] || text[defaultLanguage] || Object.values(text)[0] || defaultText : defaultText;
    case 'string':
      return text;
    default:
      return !Array.isArray(text) ? text : defaultText;
  }
};
const oldData = timestamp => (0, _moment.default)().diff(timestamp, 'hours', true) >= 1.5;
exports.oldData = oldData;
const wrongData = temperature => !(temperature >= 0 && temperature <= 100);
exports.wrongData = wrongData;
const getStatusDevice = _ref2 => {
  let {
    thresholds = {},
    value = null,
    timestamp = null,
    valueType: propValueType = ''
  } = _ref2;
  const temperature = propValueType === _constants.valueType.float ? Number(value) : null;
  const getKey = () => {
    var _thresholds$max, _thresholds$min;
    if (!timestamp || oldData(timestamp)) return _constants.tempStatusKey.oldData;
    if (wrongData(temperature)) return _constants.tempStatusKey.wrongData;
    if (temperature > (thresholds === null || thresholds === void 0 || (_thresholds$max = thresholds.max) === null || _thresholds$max === void 0 ? void 0 : _thresholds$max.value) && temperature) return _constants.tempStatusKey.isHigh;
    if (temperature < (thresholds === null || thresholds === void 0 || (_thresholds$min = thresholds.min) === null || _thresholds$min === void 0 ? void 0 : _thresholds$min.value) && temperature) return _constants.tempStatusKey.isLow;
    return _constants.tempStatusKey.optimal;
  };
  const key = getKey();
  const statusTextKey = _constants.textStatusKey[key];
  const statusColor = _constants.colorStatus[key];
  return {
    statusColor,
    statusTextKey,
    key
  };
};

/**
 * Method getCurrentStructure
 * @description This function creates a link structure for an active building and an active circulation group
 * @returns {{active: {
 * PwcPoe: {[p: string]: {}},
 * PwhC: {[p: string]: {}},
 * HtgHx: {[p: string]: {}},
 * HtgCc: {[p: string]: {}},
 * HtgHs: {[p: string]: {}},
 * HtgSys: {[p: string]: {}},
 * HtgSub: {[p: string]: {}},
 * PwhPipe: {[p: string]: {}},
 * PwhSupply: {[p: string]: {}}},
 * byHtgSys: {PwhC: {[p: string]: {}}, HtgCc: {[p: string]: {}}, PwhSupply: {[p: string]: {}}}}}
 */
exports.getStatusDevice = getStatusDevice;
const getCurrentStructure = _ref3 => {
  var _getValuesByType, _getValuesByType2, _getValuesByType4, _getValuesByType5, _getValuesByType6, _getValuesByType7, _getValuesByType9, _getValuesByType10, _getValuesByType11;
  let {
    structure = {},
    buildingId,
    activePwhC
  } = _ref3;
  const getValuesByType = type => Object.values(structure[type] || {});
  const HtgSys = (_getValuesByType = getValuesByType(_constants.ComponentTypes.HtgSys)) === null || _getValuesByType === void 0 ? void 0 : _getValuesByType.reduce((acc, item) => item[_constants.LinkTo.Building].includes(buildingId) ? _objectSpread(_objectSpread({}, acc), {}, {
    [item.id]: item
  }) : acc, {});
  const HtgSub = getValuesByType(_constants.ComponentTypes.HtgSub).reduce((acc, item) => item[_constants.LinkTo.Building].includes(buildingId) ? _objectSpread(_objectSpread({}, acc), {}, {
    [item.id]: item
  }) : acc, {});
  const HtgSysOrSub = isEmpty(HtgSys) ? HtgSub : HtgSys;
  const HtgHs = (_getValuesByType2 = getValuesByType(_constants.ComponentTypes.HtgHs)) === null || _getValuesByType2 === void 0 ? void 0 : _getValuesByType2.reduce((acc, item) => {
    var _Object$values2;
    if ((_Object$values2 = Object.values(HtgSysOrSub)) !== null && _Object$values2 !== void 0 && _Object$values2.find(obj => {
      var _obj$LinkTo$HtgHs;
      return (_obj$LinkTo$HtgHs = obj[_constants.LinkTo.HtgHs]) === null || _obj$LinkTo$HtgHs === void 0 ? void 0 : _obj$LinkTo$HtgHs.includes(item.id);
    })) {
      if (item[_constants.LinkTo.HtgHs]) {
        var _getValuesByType3;
        const htgHs2 = ((_getValuesByType3 = getValuesByType(_constants.ComponentTypes.HtgHs)) === null || _getValuesByType3 === void 0 ? void 0 : _getValuesByType3.find(c => {
          var _item$LinkTo$HtgHs;
          return (_item$LinkTo$HtgHs = item[_constants.LinkTo.HtgHs]) === null || _item$LinkTo$HtgHs === void 0 ? void 0 : _item$LinkTo$HtgHs.includes(c.id);
        })) || null;
        if (htgHs2) return _objectSpread(_objectSpread({}, acc), {}, {
          [item.id]: item,
          [htgHs2.id]: htgHs2
        });
      }
      return _objectSpread(_objectSpread({}, acc), {}, {
        [item.id]: item
      });
    }
    return acc;
  }, {});
  const HtgHx = (_getValuesByType4 = getValuesByType(_constants.ComponentTypes.HtgHx)) === null || _getValuesByType4 === void 0 ? void 0 : _getValuesByType4.reduce((acc, item) => {
    var _Object$values3, _Object$values4;
    const hasInSys = (_Object$values3 = Object.values(HtgSysOrSub)) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.find(obj => {
      var _obj$LinkTo$HtgHx;
      return (_obj$LinkTo$HtgHx = obj[_constants.LinkTo.HtgHx]) === null || _obj$LinkTo$HtgHx === void 0 ? void 0 : _obj$LinkTo$HtgHx.includes(item.id);
    });
    const hasInHs = (_Object$values4 = Object.values(HtgHs)) === null || _Object$values4 === void 0 ? void 0 : _Object$values4.find(obj => {
      var _obj$LinkTo$HtgHx2;
      return (_obj$LinkTo$HtgHx2 = obj[_constants.LinkTo.HtgHx]) === null || _obj$LinkTo$HtgHx2 === void 0 ? void 0 : _obj$LinkTo$HtgHx2.includes(item.id);
    });
    if (hasInSys || hasInHs) {
      const hxIdList = item[_constants.LinkTo.HtgHx];
      if (hxIdList !== null && hxIdList !== void 0 && hxIdList.length) {
        const structureHxById = structure[_constants.ComponentTypes.HtgHx] || {};
        return _objectSpread(_objectSpread({}, acc), {}, {
          [item.id]: item
        }, hxIdList.reduce((accList, hxId) => _objectSpread(_objectSpread({}, accList), {}, {
          [hxId]: structureHxById[hxId]
        }), {}));
      }
      return _objectSpread(_objectSpread({}, acc), {}, {
        [item.id]: item
      });
    }
    return acc;
  }, {});
  const HtgPipe = (_getValuesByType5 = getValuesByType(_constants.ComponentTypes.HtgPipe)) === null || _getValuesByType5 === void 0 ? void 0 : _getValuesByType5.reduce((acc, item) => {
    var _Object$values5;
    return (_Object$values5 = Object.values(HtgHx)) !== null && _Object$values5 !== void 0 && _Object$values5.find(obj => {
      var _obj$LinkTo$HtgPipe;
      return (_obj$LinkTo$HtgPipe = obj[_constants.LinkTo.HtgPipe]) === null || _obj$LinkTo$HtgPipe === void 0 ? void 0 : _obj$LinkTo$HtgPipe.includes(item.id);
    }) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {});
  const allHtgCc = (_getValuesByType6 = getValuesByType(_constants.ComponentTypes.HtgCc)) === null || _getValuesByType6 === void 0 ? void 0 : _getValuesByType6.reduce((acc, item) => {
    var _Object$values6, _Object$values7;
    return (_Object$values6 = Object.values(HtgSysOrSub)) !== null && _Object$values6 !== void 0 && _Object$values6.find(obj => {
      var _obj$LinkTo$HtgCc;
      return (_obj$LinkTo$HtgCc = obj[_constants.LinkTo.HtgCc]) === null || _obj$LinkTo$HtgCc === void 0 ? void 0 : _obj$LinkTo$HtgCc.includes(item.id);
    }) || (_Object$values7 = Object.values(HtgHs)) !== null && _Object$values7 !== void 0 && _Object$values7.find(obj => {
      var _obj$LinkTo$HtgCc2;
      return (_obj$LinkTo$HtgCc2 = obj[_constants.LinkTo.HtgCc]) === null || _obj$LinkTo$HtgCc2 === void 0 ? void 0 : _obj$LinkTo$HtgCc2.includes(item.id);
    }) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {});
  const allPwhSupplies = (_getValuesByType7 = getValuesByType(_constants.ComponentTypes.PwhSupply)) === null || _getValuesByType7 === void 0 ? void 0 : _getValuesByType7.reduce((acc, item) => {
    var _Object$values8, _getValuesByType8;
    return (_Object$values8 = Object.values(allHtgCc)) !== null && _Object$values8 !== void 0 && _Object$values8.find(obj => {
      var _obj$LinkTo$PwhSupply;
      return (_obj$LinkTo$PwhSupply = obj[_constants.LinkTo.PwhSupply]) === null || _obj$LinkTo$PwhSupply === void 0 ? void 0 : _obj$LinkTo$PwhSupply.includes(item.id);
    }) || (_getValuesByType8 = getValuesByType(_constants.ComponentTypes.PwhSupply)) !== null && _getValuesByType8 !== void 0 && _getValuesByType8.find(obj => {
      var _obj$LinkTo$PwhSupply2;
      return obj.building.includes(buildingId) && ((_obj$LinkTo$PwhSupply2 = obj[_constants.LinkTo.PwhSupply]) === null || _obj$LinkTo$PwhSupply2 === void 0 ? void 0 : _obj$LinkTo$PwhSupply2.includes(item.id));
    }) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {});
  /** @todo maybe split to active (connected to PwhSupply) and byHtgSys (put list of PwcPoe) */
  const PwcPoe = (_getValuesByType9 = getValuesByType(_constants.ComponentTypes.PwcPoe)) === null || _getValuesByType9 === void 0 ? void 0 : _getValuesByType9.reduce((acc, item) => item[_constants.LinkTo.Building].includes(buildingId) ? _objectSpread(_objectSpread({}, acc), {}, {
    [item.id]: item
  }) : acc, {});
  const allPwhC = (_getValuesByType10 = getValuesByType(_constants.ComponentTypes.PwhC)) === null || _getValuesByType10 === void 0 ? void 0 : _getValuesByType10.reduce((acc, item) => {
    var _Object$values9;
    return (_Object$values9 = Object.values(allPwhSupplies)) !== null && _Object$values9 !== void 0 && _Object$values9.find(obj => {
      var _obj$LinkTo$PwhC;
      return (_obj$LinkTo$PwhC = obj[_constants.LinkTo.PwhC]) === null || _obj$LinkTo$PwhC === void 0 ? void 0 : _obj$LinkTo$PwhC.includes(item.id);
    }) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {});
  const activePwhCObject = allPwhC[activePwhC] || Object.values(allPwhC)[0] || null;
  const calcSerialsSupp = function calcSerialsSupp() {
    let acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const getPreviousSupp = function getPreviousSupp() {
      let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      let cutList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      let result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const supp = cutList.find(item => item[_constants.LinkTo.PwhSupply].includes(id));
      const cutListTemp = supp ? list.filter(item => item.id !== supp.id) : list;
      return supp ? _objectSpread({
        [supp.id]: supp
      }, getPreviousSupp(supp.id, cutListTemp, result)) : result;
    };
    return getPreviousSupp(Object.keys(acc)[0], list, acc);
  };
  const activePwhSupplies = Object.values(allPwhSupplies).reduce((acc, item, index, list) => {
    var _item$LinkTo$PwhC, _item$LinkTo$PwhC2, _item$LinkTo$PwhSuppl;
    const isLastSupp = activePwhCObject !== null && activePwhCObject !== void 0 && activePwhCObject.id ? (_item$LinkTo$PwhC = item[_constants.LinkTo.PwhC]) === null || _item$LinkTo$PwhC === void 0 ? void 0 : _item$LinkTo$PwhC.includes(activePwhCObject === null || activePwhCObject === void 0 ? void 0 : activePwhCObject.id) : !((_item$LinkTo$PwhC2 = item[_constants.LinkTo.PwhC]) !== null && _item$LinkTo$PwhC2 !== void 0 && _item$LinkTo$PwhC2.length) && !((_item$LinkTo$PwhSuppl = item[_constants.LinkTo.PwhSupply]) !== null && _item$LinkTo$PwhSuppl !== void 0 && _item$LinkTo$PwhSuppl.length);
    const result = _objectSpread(_objectSpread({}, acc), isLastSupp ? {
      [item.id]: item
    } : {});
    if (index === list.length - 1 && Object.keys(result).length === 1) {
      return calcSerialsSupp(result, list);
    }
    return result;
  }, {});
  const HtgCc = Object.values(allHtgCc).reduce((acc, item) => {
    var _item$LinkTo$PwhSuppl2;
    return (_item$LinkTo$PwhSuppl2 = item[_constants.LinkTo.PwhSupply]) !== null && _item$LinkTo$PwhSuppl2 !== void 0 && _item$LinkTo$PwhSuppl2.find(_item => Object.keys(activePwhSupplies).includes(_item)) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {});
  const PwhPipe = activePwhCObject ? (_getValuesByType11 = getValuesByType(_constants.ComponentTypes.PwhPipe)) === null || _getValuesByType11 === void 0 ? void 0 : _getValuesByType11.reduce((acc, item) => {
    var _activePwhCObject$Lin;
    return (_activePwhCObject$Lin = activePwhCObject[_constants.LinkTo.PwhPipe]) !== null && _activePwhCObject$Lin !== void 0 && _activePwhCObject$Lin.includes(item.id) ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: item
    }) : acc;
  }, {}) : {};
  return {
    active: {
      HtgSys,
      HtgSub,
      HtgHs,
      HtgHx,
      HtgPipe,
      HtgCc,
      PwhSupply: activePwhSupplies,
      PwcPoe,
      PwhC: activePwhCObject ? {
        [activePwhCObject === null || activePwhCObject === void 0 ? void 0 : activePwhCObject.id]: activePwhCObject
      } : {},
      PwhPipe
    },
    byHtgSys: {
      HtgCc: allHtgCc,
      PwhC: allPwhC,
      PwhSupply: allPwhSupplies
    }
  };
};
exports.getCurrentStructure = getCurrentStructure;
getCurrentStructure.propTypes = {
  structure: _Types.structureType.isRequired,
  buildingId: _propTypes.default.string.isRequired,
  activePwhC: _propTypes.default.string
};
const getDisplayClassification = thingProductDisplayClassification => _constants.classificationByProductDisplayClass[thingProductDisplayClassification];
exports.getDisplayClassification = getDisplayClassification;
const getDisplayClassificationVersion = thingProductDisplayClassification => _constants.classificationVersionByProductDisplayClass[thingProductDisplayClassification];

/** @deprecated getDeviceModelType */
exports.getDisplayClassificationVersion = getDisplayClassificationVersion;
const getDeviceModelType = thingPaulProductCode => {
  switch (true) {
    case _constants.regularByDeviceProductCodeList.temperatureSensor.test(thingPaulProductCode):
      return _constants.sensorTypes.temperatureSensor;
    case _constants.regularByDeviceProductCodeList.smartValve.test(thingPaulProductCode):
      return _constants.sensorTypes.smartValve;
    case _constants.regularByDeviceProductCodeList.energyValve.test(thingPaulProductCode):
      return _constants.sensorTypes.energyValve;
    case _constants.regularByDeviceProductCodeList.pump.test(thingPaulProductCode):
      return _constants.sensorTypes.pump;
    default:
      return null;
  }
};
exports.getDeviceModelType = getDeviceModelType;
const getBuildingName = _ref4 => {
  let {
    device = {},
    allBuildings = []
  } = _ref4;
  return allBuildings.reduce((acc, array) => acc.concat(array), []).reduce((acc, building) => {
    var _device$building;
    return device !== null && device !== void 0 && (_device$building = device.building) !== null && _device$building !== void 0 && _device$building.includes(building.id) ? acc + "".concat(getTextByLanguage(building === null || building === void 0 ? void 0 : building.thingBuildingStreet), " ").concat(getTextByLanguage(building === null || building === void 0 ? void 0 : building.thingBuildingHouseNumber), " ") : acc;
  }, '');
};

/**
 * Parsing color type percentage to hsl
 * @param {number} percentage
 * @param {number} hue0
 * @param {number} hue1
 * @return {string}
 */
exports.getBuildingName = getBuildingName;
const percentageToHsl = (percentage, hue0, hue1) => {
  const hue = percentage * (hue1 - hue0) + hue0;
  return 'hsl(' + hue + ', 100%, 50%)';
};
exports.percentageToHsl = percentageToHsl;
const getSignalRangeKey = exports.getSignalRangeKey = function getSignalRangeKey() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const rules = _constants.signalRanges[type];
  return Object.keys(rules).find(key => {
    const rule = rules[key];
    return !(value <= rule[0] || value > rule[1]);
  });
};

/**
 * Calculate colour range
 * @param value
 * @param type
 * @return {{percentage: (number|number), hue1: string, hue0: string, activeRangeKey: string}}
 */
const getSignalColorSettings = exports.getSignalColorSettings = function getSignalColorSettings() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const activeRangeKey = getSignalRangeKey(value, type);
  const rules = _constants.signalRanges[type];
  const rule = rules[activeRangeKey];
  const diff = !!rule[0] && !!rule[1] ? rule[1] - rule[0] : null;
  const percentageIfDiffInfinity = rule[0] !== -Infinity ? 1 : 0;
  const percentage = diff === Infinity ? percentageIfDiffInfinity : Math.abs(diff / value);
  const hue = _constants.colorsPercentRanges[activeRangeKey];
  return {
    percentage,
    hue0: hue[0],
    hue1: hue[1],
    activeRangeKey
  };
};
/**
 * Make status color
 * @param {number} value
 * @param {string} type
 * @return {string}
 */
const getSignalStatusColor = exports.getSignalStatusColor = function getSignalStatusColor(value) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value) return percentageToHsl(0, 0, 0);
  const {
    percentage,
    hue0,
    hue1
  } = getSignalColorSettings(value, type);
  return percentageToHsl(percentage, hue0, hue1);
};

/**
 * Make status color gradient
 * @param {number} value
 * @param {string} type
 * @param {number} steps
 * @return {string[]}
 */
const getSignalStatusColorGradient = _ref5 => {
  let {
    value,
    type = '',
    steps = 2
  } = _ref5;
  if (!value) return [percentageToHsl(0, 0, 0)];
  const {
    percentage,
    hue0,
    hue1,
    activeRangeKey
  } = getSignalColorSettings(value, type);
  const accuracy = 0.7;
  const startPercentage = percentage - accuracy;
  const endPercentage = percentage + accuracy;
  const stepPercentage = Math.abs(endPercentage - startPercentage) / steps;
  let tempPercentage = startPercentage;
  const percentages = [...Array(steps)].map(() => {
    tempPercentage += stepPercentage;
    return tempPercentage;
  });
  return percentages.map(percent => percentageToHsl(percent, hue0, hue1));
};

/**
 * In-depth comparison for differences
 * @param {*} a
 * @param {*} b
 * @return {boolean|this is string[]}
 */
exports.getSignalStatusColorGradient = getSignalStatusColorGradient;
const areEqual = (a, b) => {
  if (a === b) return true;
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
  if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
  if (a.prototype !== b.prototype) return false;
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  return keys.every(k => areEqual(a[k], b[k]));
};

/**
 * Makes the first letter uppercase
 * @param {string} str
 * @return {string}
 */
exports.areEqual = areEqual;
const ucFirst = exports.ucFirst = function ucFirst() {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
};

/**
 * Function for determining whether a value exists
 * @param {string|number} v
 * @return {boolean}
 */
const valueExist = v => typeof v !== 'undefined' && v != null;

/**
 * Function determines whether the text is placed in the field
 * @param {Element} e
 * @return {boolean}
 */
exports.valueExist = valueExist;
const textIsPlacedInBlock = e => e.clientWidth < e.scrollWidth || e.clientHeight < e.scrollHeight;

/**
 * Function determines whether the temperature is correct
 * @param {string|number} t - temperature
 * @return {boolean}
 */
exports.textIsPlacedInBlock = textIsPlacedInBlock;
const getIsCorrectTemperature = t => t && t > 0 && t < 100;
exports.getIsCorrectTemperature = getIsCorrectTemperature;
const getSupportedImg = props => {
  var _ref6, _urls, _ref7, _urls$imgSizeKey;
  const {
    urls = {},
    imgSizeKey,
    defaultImg = {},
    webpSupport
  } = props;
  if (webpSupport === null) return null;
  const webpFormatKey = 'Webp';
  return webpSupport ? (_ref6 = (_urls = urls === null || urls === void 0 ? void 0 : urls["".concat(imgSizeKey).concat(webpFormatKey)]) !== null && _urls !== void 0 ? _urls : defaultImg.webp) !== null && _ref6 !== void 0 ? _ref6 : null : (_ref7 = (_urls$imgSizeKey = urls === null || urls === void 0 ? void 0 : urls[imgSizeKey]) !== null && _urls$imgSizeKey !== void 0 ? _urls$imgSizeKey : defaultImg.original) !== null && _ref7 !== void 0 ? _ref7 : null;
};
exports.getSupportedImg = getSupportedImg;
getSupportedImg.propTypes = {
  urls: _Types.hasimagesType,
  imgSizeKey: _Types.imgSizeKeyType.isRequired,
  webpSupport: _propTypes.default.bool,
  defaultImg: _propTypes.default.shape({
    webp: _propTypes.default.string,
    original: _propTypes.default.string
  })
};
const parseByValueType = (value, propValueType) => {
  switch (propValueType) {
    case _constants.valueType.bool:
      return value === 'true';
    case _constants.valueType.int:
    case _constants.valueType.float:
      return Number(value);
    default:
      return value;
  }
};
exports.parseByValueType = parseByValueType;
parseByValueType.propTypes = {
  value: _propTypes.default.string,
  valueType: _propTypes.default.oneOf(Object.values(_constants.valueType))
};
parseByValueType.returnType = _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.bool, _propTypes.default.number]);
const throwErrorIfIsNotCondition = (condition, message) => {
  if (!condition) {
    throw new Error(message);
  }
};

/**
 * Function to call toast alert
 * @param {string} type
 * @param {string} title
 * @param {string} message
 */
exports.throwErrorIfIsNotCondition = throwErrorIfIsNotCondition;
const toastMessageCreator = exports.toastMessageCreator = function toastMessageCreator(title, message) {
  let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.alertTypes.error;
  switch (type) {
    case _constants.alertTypes.success:
      return _reactToastify.toast.success( /*#__PURE__*/_react.default.createElement(_ToastContent.ToastContent, {
        type,
        title,
        message
      }));
    default:
      return _reactToastify.toast.error( /*#__PURE__*/_react.default.createElement(_ToastContent.ToastContent, {
        type,
        title,
        message
      }));
  }
};